export default __webpack_public_path__ + "static/media/step3.ee8b8438.png";